import { WalkingBookingErrorCode } from 'actions/bookings/BookingsErrors';
import { MarketplaceServiceCategory } from 'types/Marketplace';
import { SessionBusinessArea } from 'types/OnlineBooking';
import { SESSION_AREA_COPY } from 'types/Walking';

const sessionBookingErrorCopy = (
    businessArea: SessionBusinessArea
): Record<WalkingBookingErrorCode, string> => {
    const { staffNoun, serviceNoun } = SESSION_AREA_COPY[businessArea];

    return {
        session_full: 'That time just filled up. Please pick another time.',
        session_not_available: 'That time is no longer available. Please pick another time.',
        address_out_of_zone:
            'Your address is no longer covered at that time. Please pick another time or update your address.',
        staff_unavailable: `That ${staffNoun} is no longer available at that time. Please pick another time.`,
        outside_lead_time: 'That date is outside the booking window. Please pick another date.',
        duplicate_pet_service_day: `This pet already has this ${serviceNoun} booked that day. Please pick another day.`
    };
};

const WALKING_BOOKING_ERROR_FALLBACK =
    'That time is no longer available. Please pick another time.';

export const walkingBookingErrorCopy = (
    code?: string,
    petName?: string,
    businessArea: SessionBusinessArea = MarketplaceServiceCategory.WALKING
): string => {
    const name = petName?.trim();
    const copy = sessionBookingErrorCopy(businessArea);

    if (code === 'duplicate_pet_service_day' && name) {
        return `${name} already has this ${SESSION_AREA_COPY[businessArea].serviceNoun} booked that day. Please pick another day.`;
    }

    if (code && code in copy) {
        return copy[code as WalkingBookingErrorCode];
    }

    return WALKING_BOOKING_ERROR_FALLBACK;
};
